import React, { useEffect, useState } from "react";
import AddBidderModal from "../banker/bidders/addBidder";
import {
  addBidderForEvent,
  bulkFileOwnerServicechange,
  getAuctionEventById,
  getAuctionEventByUuid,
} from "services";
import createJointBidderPayload from "./createJointBidderPayload";
import CustomErrorHandlingModal from "./CustomErrorHandlingModal";
interface AddJointBiddersModalProps {
  biddersCount: number;
  router: any;
  eventId?: string | string[];
  excludeEmails: string[];
  setJointBidderCount: React.Dispatch<React.SetStateAction<number>>;
  onAction: (action: string) => void;
}

export const AddJointBiddersModal = ({
  biddersCount,
  router,
  excludeEmails,
  setJointBidderCount,
  onAction,
  eventId,

  ...props
}: AddJointBiddersModalProps) => {
  const [activeStep, setActiveStep] = useState(0);
  const [allBiddersData, setAllBiddersData] = useState<any>();
  const [primaryBidderIndex, setPrimaryBidderIndex] = useState(-1);
  type ErrorType = "validation" | "api";
  const [isErrorHandlingModalOpen, setIsErrorHandlingModalOpen] = useState<{
    open: boolean;
    type: ErrorType;
  }>({
    open: false,
    type: "validation",
  });
  const [errorHandlingModalData, setErrorHandlingModalData] =
    useState<any>(null);
  const [isOverwrite, setIsOverwrite] = useState(false);

  useEffect(() => {
    if (biddersCount) {
      const biddersArray = Array.from({ length: Number(biddersCount) }, () => ({
        name: "",
        email: "",
        pan: "",
        mobile_number: "",
        agreement_signed: false,
        application_form_filled: false,
        kyc_verified: false,
        emd_amount_paid: false,
      }));
      setAllBiddersData(biddersArray);
    }
  }, [biddersCount]);

  const handleNextStep = (form: any) => {
    if (form.validate()) {
      setAllBiddersData((prevData: any) => {
        const updatedData = [...(prevData || [])];
        updatedData[activeStep] = form.value;
        // Remove after error correction
        updatedData[activeStep]["email1"] = form.getField("email");

        return updatedData;
      });

      setActiveStep((prevStep) => prevStep + 1);
    }
  };

  const validateBidders = (allBiddersData: any): boolean => {
    let isValid = true;

    const emailIdx = new Map<string, number>();
    const mobileIdx = new Map<string, number>();
    const panIdx = new Map<string, number>();

    allBiddersData.forEach((b: any, idx: number) => {
      b.errors = {};
      if (!b.email) {
        b.errors.email = "Bidder Email is required";
        isValid = false;
      }
      if (!b.mobile_number) {
        b.errors.mobile_number = "Bidder Mobile number is required";
        isValid = false;
      }
      if (!b.pan) {
        b.errors.pan = "Bidder PAN is required";
        isValid = false;
      }

      if (b.email) {
        if (emailIdx.has(b.email)) {
          b.errors.email = "Email must be unique";
          allBiddersData[emailIdx.get(b.email)!].errors!.email =
            "Email must be unique";
          isValid = false;
        } else {
          emailIdx.set(b.email, idx);
        }
      }

      if (b.mobile_number) {
        if (mobileIdx.has(b.mobile_number)) {
          b.errors.mobile_number = "Mobile number must be unique";
          allBiddersData[
            mobileIdx.get(b.mobile_number)!
          ].errors!.mobile_number = "Mobile number must be unique";
          isValid = false;
        } else {
          mobileIdx.set(b.mobile_number, idx);
        }
      }
    });

    if (!isValid) {
      const allErrors = allBiddersData.map((b: any, idx: number) => ({
        index: idx,
        ...b.errors,
      }));
      // console.log("allErrors: ", allErrors);
      setErrorHandlingModalData(allErrors);

      // setIsErrorHandlingModalOpen({ open: true, type: "validation" });
    }

    return isValid;
  };

  const handlePreviousStep = () => {
    setActiveStep((prevStep) => prevStep - 1);
  };

  const handleSubmitAllBidders = async ({ selectedFiles, randomID }: any) => {
    let for_event = eventId;
    setPrimaryBidderIndex(0);
    try {
      console.log("see the payload here", allBiddersData);

      const eventData: any = await getAuctionEventByUuid(for_event);
      let bankerEmail = eventData?.meta?.assigned_ao?.email;
      let bankName = eventData?.bank?.name;
      let currentBranch = eventData?.branch?.name;

      const cleanedData = allBiddersData.map((b: any, idx: number) => {
        b.email = b.email1.toLowerCase();
        return b;
      });

      console.log("cleaned data", cleanedData);

      if (!validateBidders(cleanedData) && setActiveStep) {
        console.log("Invalid bidders data", cleanedData);
        setIsErrorHandlingModalOpen({ open: true, type: "validation" });
        setActiveStep(0);
        return;
      }
      const payload = await createJointBidderPayload(
        eventData,
        cleanedData,
        bankerEmail,
        bankName,
        currentBranch,
        primaryBidderIndex,
        isOverwrite
      );
      console.log("payload: ", payload);
      const res: any = await addBidderForEvent(payload);

      if (!res?.uuid) {
        router.back();
        return;
      }
      await Promise.all([
        selectedFiles?.length
          ? bulkFileOwnerServicechange({
              older_id: randomID,
              newer_id: res.uuid,
            })
          : null,
      ]);
      router.back();
    } catch (err: any) {
      console.error(
        "Error in joint-creation",
        err?.response?.status,
        err?.response?.data
      );
      if (
        err?.response?.status === 422 &&
        err?.response?.data?.message?.message === "Identity conflict" &&
        setActiveStep
      ) {
        console.log();
        setErrorHandlingModalData([
          {
            index: primaryBidderIndex,
            ...err?.response?.data?.message?.errorDetails,
          },
        ]);
        setActiveStep(activeStep > 0 ? activeStep - 1 : 0);
      }
      if (
        err?.response?.status === 422 &&
        err?.response?.data?.message ===
          "Identity conflict(s) in joint bidders" &&
        setActiveStep
      ) {
        console.log(
          "err?.response?.data?.errors: ",
          err?.response?.data?.errors
        );
        const data = err?.response?.data?.errors.filter(
          (detail: any) => detail?.errorDetails
        );
        console.log("data: ", data);
        const errorData = [];
        for (let i = 0; i < data?.length; i++) {
          errorData.push({
            email: data[i].errorDetails.email,
            mobile_number: data[i].errorDetails.mobile,
          });
        }

        setErrorHandlingModalData(errorData || []);
        setActiveStep(activeStep > 0 ? activeStep - 1 : 0);
      }
      setIsErrorHandlingModalOpen({ open: true, type: "api" });
    }
  };

  const handleCloseButton = (action: string) => {
    if (action === "no") setJointBidderCount(0);
  };

  return (
    <div className="fixed inset-0 z-50 flex  items-center justify-center bg-black/50">
      <div className="bg-white shadow-xl  w-full max-w-4xl relative">
        <AddBidderModal
          activeStep={activeStep}
          setActiveStep={setActiveStep}
          allBiddersData={allBiddersData}
          setAllBiddersData={setAllBiddersData}
          primaryBidderIndex={primaryBidderIndex}
          setPrimaryBidderIndex={setPrimaryBidderIndex}
          onAction={handleCloseButton}
          router={router}
          handleSubmitAllBidders={handleSubmitAllBidders}
          heading={"Add Joint Bidders"}
          type={"create"}
          description={""}
          prefillData={allBiddersData?.[activeStep] ?? []}
          excludeEmails={excludeEmails}
          callback={async (form: any, formValue: any) => {}}
          biddersCount={biddersCount}
          color={"bg-blue-50 text-blue-500"}
          handleNextStep={handleNextStep}
          jointBiddersCreate={true}
          handlePreviousStep={handlePreviousStep}
          {...props}
        />
        {isErrorHandlingModalOpen?.open && (
          <CustomErrorHandlingModal
            errorType={isErrorHandlingModalOpen?.type || "validation"}
            onClose={setIsErrorHandlingModalOpen}
            errorValue={errorHandlingModalData}
            setIsErrorHandlingModalOpen={setIsErrorHandlingModalOpen}
            setErrorHandlingModalData={setErrorHandlingModalData}
            errorHandlingModalData={errorHandlingModalData}
            handleAddBidderAnyway={handleSubmitAllBidders}
            setIsOverwrite={setIsOverwrite}
          />
        )}
      </div>
    </div>
  );
};
